<template>
    <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                {{ title }}
                <div class="card-header-actions">
                    <b-button variant="success mr-1" @click="add()"><i class="fa fa-plus"></i>
                        Add</b-button>
                    <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>
                        Export</b-button>
                </div>
            </div>
            <b-table class="mb-0" ref="table" outlined responsive striped hover small style="font-size: smaller"
                :fields="tblData.fields" :items="data" :current-page="tblData.page" :per-page="tblData.limit"
                :sort-by.sync="tblData.sortBy" :sort-desc.sync="tblData.sortDesc" :key="tblData.limit"
                @row-clicked="rowClicked" show-empty :busy="isBusy">
                <template v-slot:cell(index)="data">{{
                        (tblData.page - 1) * tblData.limit + (data.index + 1)
                }}</template>
                <template v-slot:cell(action)="data">
                    <div class="text-center">
                        <a href="javascript:void(0)" @click="edit(data.item)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
                            <i class="fa fa-trash"></i>
                        </a>
                    </div>
                </template>
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <template v-slot:cell(empty)="data">
                    <h4>{{ data.emptyText }}</h4>
                </template>
                <template v-slot:cell(emptyfiltered)="data">
                    <h4>{{ data.emptyFilteredText }}</h4>
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col cols="4">
                    <div>
                        Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
                        to
                        <span v-if="tblData.page * tblData.limit > tblData.total">{{
                                tblData.total
                        }}</span>
                        <span v-else>{{ tblData.page * tblData.limit }}</span>
                        of {{ tblData.total | numFormat }} entries
                    </div>
                </b-col>
                <b-col cols="4">
                    <b-form-group label-cols="3" label style="margin-top: 0 !important">
                        <b-input-group>
                            <b-input-group-prepend class="mr-2">
                                <label>Limit per page</label>
                            </b-input-group-prepend>
                            <div class="d-flex">
                                <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit"
                                    size="sm" style="width: 80px" />
                            </div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
                        v-model="tblData.page">
                    </b-pagination>
                </b-col>
            </b-row>
        </b-card>
        <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../data/dropdown";
import toastr from "mini-toastr";
import crud from "../apis/crud";
toastr.init();
export default {
    components: { Loading },
    data() {
        return {
            showFilter: true,
            isBusy: false,
            showDelConfirm:false,
            option:{},
            tblData: {
                fields: [],
                page: 1,
                limit: 15,
                total: 0,
                sortBy: "",
                sortDesc: false,
                tablename: this.$route.meta.tablename,
                customQuery: "",
                debtorFullName: "",
                address: "",
                customerID: "",
            },
        };
    },
    computed: {
        title() {
            return this.$route.meta.title;
        },
        tablename() {
            return this.$route.meta.tablename;
        },
        addroutename() {
            return this.$route.meta.addroutename;
        }
    },
    watch: {
        title(val) {
            this.tblData.tablename = this.$route.meta.tablename;
            this.initialize();
            this.refresh();
        },
    },
    mounted() {
        console.log("mounted");
    },
    async created() {
        console.log("created");
        this.initialize();
    },
    methods: {
        async initialize() {
            const fields = [
            {
                    key: "action",
                    label: "-",
                    thClass: "text-center",
                    thStyle: "min-width:60px",
                },
                {
                    key: "index",
                    label: "No.",
                    thClass: "text-center",
                    sortable: true,
                }
                
            ];
            const {list,option} = await crud.getField(this.tblData);
            this.option = option;
            list.map((dt) => {
                if (dt.Field != "compcode" && dt.Field != "isdeleted") {
                    fields.push({
                        key: dt.Field,
                        label: dt.Field,
                        thClass: "text-center",
                        sortable: true,
                    });
                }
            });
            fields.push({
                key: "action",
                label: "-",
                thClass: "text-center",
            });
            this.tblData.fields = fields;
        },
        rowClicked(record, index) {
            if (this.model && this.model._rowVariant) {
                delete this.model._rowVariant;
            }
            this.model = record;
            record._rowVariant = "info";
            this.$forceUpdate();
            // }
        },
        async refresh() {
            try {
                this.$refs.table.refresh();
            } catch (error) {
                this.isBusy = false;
                if (error.message) {
                    toastr.error(error.message, "ERROR MESSAGE", 10000);
                } else {
                    toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
                }
            }
        },
        async data() {
            try {
                this.isBusy = true;
                const filter = this.$store.state.filter;
                let filtered = false;
                for (var key in filter.debiturList) {
                    this.tblData[key] = filter.debiturList[key];
                    filtered = true;
                }
                if (filtered === true) {
                    this.showFilter = filtered;
                    delete filter.debiturList;
                    this.$store.commit("filter", filter);
                    // this.$store.commit("filter", {});
                }
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                const list = await crud.list(this.tblData);
                this.isBusy = false;
                return list;
            } catch (error) {
                this.isBusy = false;
                if (error.message) {
                    toastr.error(error.message, "ERROR MESSAGE", 10000);
                } else {
                    toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
                }
            }
        },
        async add() {
            router.push({ name: this.addroutename });
        },
        async edit(obj) {
            let params={};
            params[this.option.key]=obj[this.option.key];
            router.push({ name: this.addroutename ,params});
        },
        deleteConfirm(item) {
            this.rowClicked(item)
            this.showDelConfirm = true;
        },
        async deleteData(){

        }
    },
};
</script>

<style>

</style>